import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { SortMenuItem } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'NumberListSort',
  props: {
    modelValue: {
        type: Array<SortMenuItem>,
    },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const sortMenuItems = ref([
    {
        label: t('number.sortMenu.items.number'),
        key: 'number',
    },
    {
        label: t('number.sortMenu.items.city'),
        key: 'city',
    },
    {
        label: t('number.sortMenu.items.state'),
        key: 'state',
    },
] as SortMenuItem[]);

const props = __props;

const emit = __emit;

const updateValue = (value: string) => {
    emit('update:modelValue', value);
};

return (_ctx: any,_cache: any) => {
  const _component_UiSortMenu = _resolveComponent("UiSortMenu")!

  return (_openBlock(), _createBlock(_component_UiSortMenu, {
    items: sortMenuItems.value,
    "model-value": props.modelValue,
    "onUpdate:modelValue": updateValue
  }, null, 8, ["items", "model-value"]))
}
}

})